import { BarsOutlined } from '@ant-design/icons';
import { Button, Checkbox, Dropdown, Space } from 'antd';
import React, { useState } from 'react';

import { MonitorState } from './monitor.provider';

type Props = {
  setting: MonitorState['settings'];
  onChange?: (settings: Partial<MonitorState['settings']>) => void;
  placement?: 'bottomLeft' | 'bottomCenter' | 'bottomRight' | 'topLeft' | 'topCenter' | 'topRight';
};

export const PanelSwitchDropdown: React.FC<Props> = ({ setting, onChange, placement = 'bottomLeft' }) => {
  const [open, setOpen] = useState(false);

  const handleOpenChange = (next: boolean) => setOpen(next);

  const content = (
    <div
      style={{
        padding: 12,
        width: 220,
        background: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: 8,
        boxShadow: '0 6px 16px rgba(0,0,0,0.08)',
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div style={{ fontWeight: 600, marginBottom: 8 }}>展示模块</div>

      <Space style={{ marginBottom: 8 }} direction="vertical">
        <Checkbox
          defaultChecked={setting.showDetail}
          onChange={() => {
            setOpen(false);
            onChange({
              showDetail: !setting.showDetail,
            });
          }}
        >
          卡片详情
        </Checkbox>
        <Checkbox
          defaultChecked={setting.showSetting}
          onChange={() => {
            setOpen(false);
            onChange({
              showSetting: !setting.showSetting,
            });
          }}
        >
          设置
        </Checkbox>
      </Space>
    </div>
  );

  return (
    <Dropdown
      open={open}
      onOpenChange={handleOpenChange}
      dropdownRender={() => content}
      trigger={['click']}
      placement={placement}
    >
      <Button size="small" type="link" icon={<BarsOutlined />}>
        展示模块
      </Button>
    </Dropdown>
  );
};

export default PanelSwitchDropdown;
